import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material';
import { classToPlain } from 'class-transformer';
import { FormComponentContainer } from 'lib-shared';
import { DynamicFormGroup } from 'ngx-dynamic-form-builder';
import { MatIconEnum } from '../shared/models/common/mat-icon.enum';
import { OrderQuantityForm } from '../shared/models/product/product-list/order-quantity.form';
import { ProductListItem } from '../shared/models/product/product-list/product-list-item';
import { PopupService } from '../shared/services/popup.service';
import { OrderQuantityService } from '../shared/services/product/order-quantity.service';
import { ProductListService } from '../shared/services/product/product-list.service';

@Component({
  selector: 'app-order-minimum-quantity',
  templateUrl: './order-minimum-quantity.component.html',
  styleUrls: ['./order-minimum-quantity.component.scss']
})
export class OrderMinimumQuantityComponent extends FormComponentContainer<OrderQuantityForm> implements OnInit {
  showSelectedProducts: boolean = false;
  productList: ProductListItem[]= [];
  readonly MatIconEnum = MatIconEnum;
  isDeleted: boolean = false;
  showSpinner = false;


  @Input()
  orderquantity: OrderQuantityForm;

  @Output()
  refreshList = new EventEmitter<void>();

  constructor(
    private _productListService: ProductListService,
    private orderQuantityService: OrderQuantityService,
    private showPop: PopupService,
  ) {
    super();
   }

  ngOnInit() {
    super.ngOnInit();
    this._resetForm(this.orderquantity);
    this.getAllProducts();
    this.showSelectedProducts = !this.orderquantity.for_all_products;

  }


  protected _getFormGroup(): DynamicFormGroup<OrderQuantityForm> {
    const form = this._fb.group(OrderQuantityForm, classToPlain(new OrderQuantityForm()));
    return form;
  }

  private async getAllProducts(): Promise<void> {
    try {
      this.productList = await this._productListService
        .getAllProducts();
    } catch (err) {
      this._handleBackendErrors(err)
    }
  }

  public toggle(event: MatSlideToggleChange) {  
    this.showSelectedProducts = !event.checked;
  }

  async onSave(): Promise<void> {
    this.messages.clearMessages();
    this.showSpinner = true;

    this._validateForm();

    if(this.showSelectedProducts == true && (this.form.object.for_selected_products == null || this.form.object.for_selected_products.length == 0)){ 
      this.errors.setErrorsFromBackend({for_selected_products: 'Please select any product.'});
      this.form.controls['for_selected_products'].markAsTouched();
      return;
    }
    this.form.controls['for_selected_products'].markAsTouched();
    if(this.form.valid){
      if(this.form.object.for_all_products == true){
        this.form.controls['for_selected_products'].setValue([]);
      }

      try{
        await this.orderQuantityService.editOrderQuantity(this.form.value);
        await this.showPop.showSuccessPopup("Order minimum quantity updated successfully.");
        this.refreshList.emit();
      }
      catch(err) {
        this._handleBackendErrors(err);
      }
    }
    this.showSpinner = false;

  }

  async deleteOrderQuantity(orderquantity:  OrderQuantityForm): Promise<void> {
    this.messages.clearMessages();
    this.showSpinner = true;

    const response = await this.showPop.showDeletePopup(`Do you want to delete this setting?`);
    try{

      if(response)
      {
        const orderQuantity = await this.orderQuantityService.deleteOrderQuantity(orderquantity.id);  
        this.isDeleted = true;
        this.refreshList.emit();
      }
    }
    catch(err){
      this._handleBackendErrors(err)
    }
    this.showSpinner = false;

  }
}
